import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, tap, take, exhaustMap } from "rxjs";
import { LoaderService } from "./loader.service";
import { AuthenticationService } from "./authentication.service";
import { ActionResultList, DEFAULT_PAGE_SIZE, EventItemType, EventRaceItem, FindEventsRequest, FindRacesRequest, ItemType } from "@model";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class EventRaceService {
  private static _eventRaces = new BehaviorSubject<ActionResultList<EventRaceItem[], number> | null>(null);
  private static _hasMoreEventRace = new BehaviorSubject<boolean>(false);

  get eventRaces() {
    return EventRaceService._eventRaces;
  }

  get hasMoreEventRace() {
    return EventRaceService._hasMoreEventRace;
  }

  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private authService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  findEventRacesPaged(itemType: ItemType, eventItemType: EventItemType, page: number, onSuccess: () => void, onError: () => void) {
    const endpoint = itemType === ItemType.EVENT ? "/api/public/events/filter" : "/api/races/userallraces";
    const request = itemType === ItemType.EVENT ? FindEventsRequest.createEventRacePagedFilter(page, eventItemType) : FindRacesRequest.createLandingRacesPagedFilterRequest(page, eventItemType);

    this.loaderService.startLoading();
    const request$ = itemType === ItemType.EVENT ? this.http.post<ActionResultList<EventRaceItem[], number>>(this.environmentService.getApiUrl() + endpoint, request) : this.authService.jwtResponse.pipe(take(1), exhaustMap(() => this.http.post<ActionResultList<EventRaceItem[], number>>(this.environmentService.getApiUrl() + endpoint, request)));

    request$.pipe(tap(() => this.loaderService.dismissLoading())).subscribe({
      next: (actionResultList) => this.handleResponse(actionResultList),
      error: onError
    });
  }

  private handleResponse(actionResultList: ActionResultList<EventRaceItem[], number>) {
    if (actionResultList.result) {
      this.hasMoreEventRace.next(actionResultList.result.length > DEFAULT_PAGE_SIZE);
      actionResultList.result = actionResultList.result.slice(0, DEFAULT_PAGE_SIZE);
      if (this.eventRaces.getValue()?.result) {
        actionResultList.result = this.eventRaces.getValue()!.result!.concat(actionResultList.result);
      }
    }
    this.eventRaces.next(actionResultList);
  }
}
